import { styled } from "styled-components";
import { rgba } from "polished";
const SelectWrapper = styled("div")(({ theme }) => ({
  color: theme.color.default,
  lineHeight: theme.lineHeight.default,
  flex: "1 1 0",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.normal,
  position: "relative"
}));
const SelectInner = styled("div")(({ theme }) => ({
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  position: "relative"
}));
const SelectMenu = styled("div")({
  outline: 0,
  transformOrigin: "inherit"
});
const SelectPopover = styled("div")(
  ({ theme }) => ({
    backgroundColor: "white",
    borderRadius: 2,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    boxSizing: "border-box",
    color: theme.color.default,
    display: "flex",
    flexDirection: "column",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.default,
    position: "relative",
    transformOrigin: "inherit"
  }),
  ({ $menuHeight }) => ({ maxHeight: $menuHeight })
);
const SelectSearch = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.borderColor}`,
  padding: 2
}));
const SelectGroup = styled("section")(
  {
    padding: "0 4px"
  },
  ({ $groupVariant, theme }) => ({
    divider: {
      borderBottom: `1px solid ${theme.borderColor}`,
      padding: 4,
      "&:first-child": {
        paddingTop: 0
      },
      "&:last-child": {
        borderBottom: 0,
        paddingBottom: 0
      }
    }
  })[$groupVariant]
);
const SelectGroupHeading = styled("div")(({ theme }) => ({
  color: rgba(0, 0, 0, 0.45),
  fontSize: theme.fontSize.sm,
  fontWeight: theme.fontWeight.medium,
  lineHeight: theme.lineHeight.sm,
  padding: "4px 8px",
  textTransform: "uppercase"
}));
const SelectItem = styled("div")(
  ({ theme }) => ({
    borderRadius: 2,
    cursor: "pointer",
    padding: "4px 8px",
    textOverflow: "ellipsis",
    "&:active": {
      backgroundColor: theme.color.gray4
    }
  }),
  ({ $highlighted, theme }) => $highlighted ? {
    backgroundColor: theme.color.gray3
  } : void 0,
  ({ "aria-selected": selected, $highlighted, theme }) => selected ? {
    backgroundColor: $highlighted ? theme.color.blue2 : theme.color.blue1,
    color: theme.color.blue6,
    fontWeight: theme.fontWeight.medium,
    "&:active": {
      backgroundColor: theme.color.blue2
    }
  } : void 0,
  ({ indent }) => ({
    paddingLeft: indent ? 16 : void 0
  }),
  ({ $wrap }) => !$wrap ? {
    overflow: "hidden",
    whiteSpace: "nowrap"
  } : void 0
);
const SelectGroupPlaceholder = styled("div")(({ theme }) => ({
  color: theme.color.gray6,
  padding: "4px 8px"
}));
export {
  SelectGroup,
  SelectGroupHeading,
  SelectGroupPlaceholder,
  SelectInner,
  SelectItem,
  SelectMenu,
  SelectPopover,
  SelectSearch,
  SelectWrapper
};
